<template>
  <CSidebar
    class="asideBar bg-gray-200"
    aside
    :minimize="minimize"
    unfoldable
    :show="show"
    @update:show="(value) => $store.commit('set', ['asideBarShow', value])"
  >
    <section class="">
      <CSidebarMinimizer class="minimizer bg-transparent" @click.native="$store.commit('toggle', 'asideBarMinimize')" />

      <section>
        <CCol class="p-0">
          <components :is="this.componentName" :minimizeBar="minimize" />
        </CCol>
      </section>
    </section>
  </CSidebar>
</template>

<script>
import nav from './_nav'

export default {
  name: 'TheAsideBar',
  extends: nav,
  props: {
    componentName: {
      type: String,
      required: true,
    },
  },
  components: {},
  created() {},
  mounted() {},
  computed: {
    show() {
      return true
    },
    hasComponent() {
      return this.$store.state.show
    },
    minimize() {
      return this.$store.state.asideBarMinimize
    },
  },
}
</script>

<style lang="scss" scoped>
.asideBar {
  position: absolute;
  right: 0;
  z-index: 100 !important;
  bottom: initial;
  height: 100%;
  overflow-y: auto;
  overflow-x: none;

  .c-sidebar-nav {
    padding-bottom: 0;
  }

  .minimizer {
    position: relative;
  }
}

.sticky {
  position: sticky;
  top: 20px;
}
</style>
